/*
 * OWL - Aceptación de términos y condiciones antes de pagar (versión Savor).
 * Igual lógica que en el tema Mixto, pero con delegación de eventos y
 * MutationObserver porque Savor re-renderiza el drawer/resumen del carrito
 * (morph de secciones) y destruiría listeners directos.
 * REGLA: sin sessionStorage — la evidencia vive como atributo del carrito.
 */
(() => {
  const CART_ATTRIBUTE = 'Términos y condiciones';
  const ACCEPTED_VALUE = 'Aceptados por el cliente antes de pagar';

  let accepted = false;

  const applyState = () => {
    document.querySelectorAll('[data-owl-terms-ack]').forEach((checkbox) => {
      if (checkbox.checked !== accepted) checkbox.checked = accepted;
      const scope = checkbox.closest('.cart__ctas');
      const button = scope && scope.querySelector('button[name="checkout"]');
      // OJO: escribir SOLO cuando cambia. Asignar .disabled re-escribe el
      // atributo aunque el valor sea igual y eso dispara el MutationObserver
      // de abajo -> bucle infinito que congela la pagina.
      if (button && button.disabled !== !accepted) button.disabled = !accepted;
    });
  };

  // Las peticiones se encadenan para que un marcar/desmarcar rápido no llegue
  // desordenado, y se reintenta una vez si el servidor responde con error.
  const postAttributes = (attributes) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes }),
    });

  let saveQueue = Promise.resolve();
  const saveCartAttribute = () => {
    const attributes = {};
    attributes[CART_ATTRIBUTE] = accepted ? ACCEPTED_VALUE : '';
    saveQueue = saveQueue
      .then(() => postAttributes(attributes))
      .then((response) => {
        if (response.ok) return response;
        return new Promise((resolve) => setTimeout(resolve, 800)).then(() => postAttributes(attributes));
      })
      .catch(() => {});
  };

  document.addEventListener('change', (event) => {
    const checkbox = event.target;
    if (!checkbox || !checkbox.matches || !checkbox.matches('[data-owl-terms-ack]')) return;
    accepted = checkbox.checked;
    applyState();
    saveCartAttribute();
  });

  // El morph de Savor puede parchear el checkbox en el lugar (sin agregar
  // nodos), así que además del observer se escucha el evento estándar de
  // actualización de carrito y se re-aplica el estado al resolverse.
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.promise && typeof event.promise.then === 'function') {
      // El re-render de la seccion del carrito ocurre DESPUES de resolverse
      // la promesa (fetch extra de renderSection): re-aplicar con margen.
      event.promise
        .then(() => {
          setTimeout(applyState, 100);
          setTimeout(applyState, 800);
        })
        .catch(() => {});
    } else {
      setTimeout(applyState, 800);
    }
  });

  // Savor reemplaza o parchea el HTML del resumen al actualizar el carrito.
  // El morph puede modificar atributos en el lugar (sin agregar nodos), asi
  // que se observan tambien los cambios del atributo disabled del boton.
  // Sin riesgo de bucle: applyState solo escribe cuando el valor cambia.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        applyState();
        return;
      }
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (
          (node.matches && (node.matches('[data-owl-terms-ack]') || node.matches('button[name="checkout"]'))) ||
          (node.querySelector && node.querySelector('[data-owl-terms-ack], button[name="checkout"]'))
        ) {
          applyState();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });

  // Garantia dura: aunque el boton quedara habilitado visualmente por un
  // re-render, el clic no pasa sin aceptar los terminos (fase captura, antes
  // que cualquier otro handler; el modal de contraentrega corre despues).
  document.addEventListener(
    'click',
    (event) => {
      const button = event.target && event.target.closest && event.target.closest('button[name="checkout"]');
      if (!button || accepted) return;
      const scope = button.closest('.cart__ctas');
      if (!scope || !scope.querySelector('[data-owl-terms-ack]')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      applyState();
      scope.querySelector('[data-owl-terms-ack]').focus();
    },
    true,
  );

  // Estado inicial: SIEMPRE desmarcado (2026-07-11, portado del Mixto DEV — antes se restauraba
  // desde el atributo del carrito y la casilla aparecia pre-marcada en visitas siguientes).
  // Si quedo un atributo de aceptacion viejo se limpia: el pedido solo debe llevarlo si se
  // marco en esta compra.
  applyState();
  fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((response) => response.json())
    .then((cart) => {
      const attributes = cart.attributes || {};
      if (attributes[CART_ATTRIBUTE]) saveCartAttribute(); // accepted es false aqui -> limpia
    })
    .catch(() => {});
})();
